import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  success: "",
  error: "",
};

const ConfirmApplicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CONFIRM_APPLY_RESPONSE:
      return {
        ...state,
        success: action.success,
        error: "",
      };
    case actionTypes.CONFIRM_APPLY_ERROR:
      return {
        ...state,
        error: action.error,
        success: "",
      };
    case actionTypes.RESET:
      return initialState;

    default:
      return state;
  }
};

export default ConfirmApplicationReducer;
